export class RemindPasswordForm {
  public constructor(public readonly email: string) {}
}
